export default __webpack_public_path__ + "static/ti_motorhome_block-a695d21d3f791809175c6b46ed2f9fbb.svg";